import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import PanelLayout from "layouts/PanelLayout";
import "styles/teacher.css";
import { TbSmartHome } from "react-icons/tb";
import test from "assets/layout_img/test.svg";
import { MdKeyboardArrowRight } from "react-icons/md";
import { toast } from "react-toastify";

const API_BASE = "https://algoritm-api-edu.uz";

const SubjectsIntro = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams(); // URL dan slug olish (:slug)

  // location.state orqali kelgan subject
  const subjectFromState = location.state?.subject;

  const [subject, setSubject] = useState(subjectFromState || null);
  const [loading, setLoading] = useState(!subjectFromState);
  const [error, setError] = useState(null);

  // Agar state orqali subject kelmasa – slug orqali API dan yuklash
  useEffect(() => {
    if (subjectFromState) {
      setSubject(subjectFromState);
      setLoading(false);
      return;
    }

    if (slug) {
      fetchSubjectBySlug(slug);
    }
  }, [slug, subjectFromState]);

  const fetchSubjectBySlug = async (currentSlug) => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("accessToken");
    if (!token) {
      setError("Token topilmadi");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(
        `${API_BASE}/api/teacher/subjects/GetBySlug/${currentSlug}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!res.ok) throw new Error("Fan yuklanmadi");

      const data = await res.json();
      const subjectData = data.data || data;

      if (!subjectData) throw new Error("Fan ma'lumotlari topilmadi");

      setSubject(subjectData);
    } catch (err) {
      setError(err.message);
      toast.error("Fan ma'lumotlari yuklanmadi");
    } finally {
      setLoading(false);
    }
  };

  const menuItems = [
    { id: 1, img: test, title: "Testlar", route: "/teacher/tests" },
    { id: 2, img: test, title: "Natijalar", route: "/teacher/results" },
    { id: 3, img: test, title: "Hujjatlar", route: "/teacher/docs" },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.4,
      },
    }),
  };

  return (
    <div>
      <div className="subject-page">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <span onClick={() => navigate("/teacher")}>
            <TbSmartHome
              style={{ fontSize: 20, color: "#01CC0D", cursor: "pointer" }}
            />
          </span>
          <span className="divider">/</span>

          {loading ? (
            <span className="current">Yuklanmoqda...</span>
          ) : error ? (
            <span className="current" style={{ color: "#dc2626" }}>
              Xato
            </span>
          ) : (
            <span className="current">
              {subject?.fullName || subject?.name || "Nomsiz fan"}
            </span>
          )}
        </div>

        {/* Kontent */}
        {loading ? (
          <div style={{ textAlign: "center", padding: "100px" }}>
            <p>Fan ma'lumotlari yuklanmoqda...</p>
          </div>
        ) : error ? (
          <div
            style={{ textAlign: "center", padding: "100px", color: "#dc2626" }}
          >
            <p>{error}</p>
          </div>
        ) : (
          <div className="tests-flex">
            {menuItems.map((item, index) => (
              <motion.div
                key={item.id}
                className="test-card"
                custom={index}
                initial="hidden"
                animate="visible"
                variants={cardVariants}
                whileHover={{ scale: 1.03, transition: { duration: 0.25 } }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate(item.route, { state: { subject } })}
              >
                <span className="card-content">
                  <img src={item.img} alt={`${item.title} icon`} />
                  <p>{item.title}</p>
                </span>
                <button className="start-btn">
                  <MdKeyboardArrowRight style={{ fontSize: 25 }} />
                </button>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubjectsIntro;
